import { appendURL } from "utils/helper";

const BASE_API = "/api/tms/portal";
const UNPROTECTED_BASE_URL = "/apis/tms/portal";
const VALIDATE_URL = "/apis/validate";
const USER_URL = "/api/user";
const ROLE_URL = BASE_API + "/roles";
const STATS_URL = BASE_API + "/statistics";
const ONBOARDING_STATS_URL = STATS_URL + "/onboarding";
const FETCH_TERMINAL_REPORT = BASE_API + "/report/terminal";

export const routes = {
  getToken: () => "/oauth/token",

  //validations
  BVNValidation: () => UNPROTECTED_BASE_URL + "/bvn",
  pmAccountValidation: () => VALIDATE_URL + "/pmaccount",
  pmNumberValidation: () => VALIDATE_URL + "/pmnumber",
  userNameValidation: () => "/apis/tms/portal/user/validate",
  validateOTP: () => "/apis/tms/portal/validate/otp",
  aggregatorValidation: () => `${VALIDATE_URL}/aggregator`,
  submitNin: () => `${UNPROTECTED_BASE_URL}/nin`,
  guestSubmitNin: () => `${UNPROTECTED_BASE_URL}/nin-pmnumber`,

  //User
  userCreation: () => `/apis/tms/portal/user`,
  userUpdate: (userId) => `/api/tms/portal/user/${userId}`,
  setPassword: (token) => `/apis/tms/portal/user/password/${token}`,
  changePassword: () => `/apis/tms/portal/user/password/change`,
  userActions: () => USER_URL,
  forgotPassword: (email) => `/apis/tms/portal/password-reset/${email}`,
  fetchUsers: (queryParams) => `/api/tms/portal/api/user?` + queryParams,

  fetchPMAccounts: (queryParams) =>
    appendURL(`${BASE_API}/agent/account`, queryParams),

  fetchPMAccountsPost: (agentAccountId) =>
    appendURL(`${BASE_API}/agent/account/${agentAccountId}`),

  //Terminal
  registerTerminal: () => BASE_API + "/terminals",
  updateTerminal: (id) => BASE_API + "/terminals/" + id,
  fetchTerminals: (queryParams) => BASE_API + "/terminals?" + queryParams,
  downloadTerminalStatuses: (queryParams) =>
    BASE_API + "/terminals/export?" + queryParams,

  //Roles & Permission
  fetchPermissions: (queryParams) => BASE_API + "/permissions?" + queryParams,
  createRole: () => ROLE_URL,
  fetchRoles: (queryParams) => ROLE_URL + "?" + queryParams,
  updateRole: (roleId) => ROLE_URL + "/" + roleId,

  //agent
  agentAggregatorRequest: () => "",
  addPmNumber: () => BASE_API + "/agent/account",

  //Onboarding
  createAgentPersonalDetails: () => BASE_API + `/agent/personal-details`,
  updateAgentPersonalDetails: (id) =>
    BASE_API + `/agent/personal-details/${id}`,
  getAgentPersonalDetails: (queryParams) => BASE_API + "/agent?" + queryParams,
  nextOfKinInfo: (id) => BASE_API + `/agent/${id}/next-of-kin`,
  guarantorInfo: (id) => BASE_API + `/agent/${id}/guarantor`,
  updateGuarantorInfo: (agentId, guarantorId) =>
    BASE_API + `/agent/${agentId}/guarantor/${guarantorId}`,
  updateKYCStatus: (id) => BASE_API + "/agent/" + id,
  //Prone to change
  uploadKYCFiles: (agentId) => BASE_API + `/agent/${agentId}/upload`,
  downloadKYC: (agentId) => `${BASE_API}/agent/${agentId}/download`,

  //Approvals
  fetchPendingApprovals: (queryParams) =>
    BASE_API + `/approvals?${queryParams}`,
  giveApproval: () => BASE_API + "/approvals",

  //States and regions
  fetchRegions: (queryParams) =>
    `${UNPROTECTED_BASE_URL}/region${queryParams ? `?${queryParams}` : ""}`,

  //Notifications
  notificationsMgt: (queryParams) =>
    appendURL(`${BASE_API}/notifications`, queryParams),

  //Terminal statistics endpoints
  fetchTerminalStats: (queryParams) =>
    `${STATS_URL}/terminals${queryParams ? `?${queryParams}` : ""}`,
  fetchCommissionStats: (queryParams) =>
    `${STATS_URL}/commission${queryParams ? `?${queryParams}` : ""}`,
  fetchTransactionStats: (queryParams) =>
    `${STATS_URL}/transaction${queryParams ? `?${queryParams}` : ""}`,
  fetchAgentStats: (queryParams) =>
    `${STATS_URL}/agent${queryParams ? `?${queryParams}` : ""}`,

  //Onboarding Statistics endpoints
  getOnboardingSummary: (queryParams) =>
    appendURL(`${ONBOARDING_STATS_URL}/summary`, queryParams),
  getRegisteredAgents: (queryParams) =>
    appendURL(`${ONBOARDING_STATS_URL}/registered`, queryParams),
  getEnabledAgents: (queryParams) =>
    appendURL(`${ONBOARDING_STATS_URL}/enabled`, queryParams),
  getRegAgentsStats: (queryParams) =>
    appendURL(`${ONBOARDING_STATS_URL}/region`, queryParams),
  getAgentAggregatorRatio: (queryParams) =>
    appendURL(`${ONBOARDING_STATS_URL}/ratio`, queryParams),
  getRegionBreakdown: (queryParams) =>
    appendURL(`${ONBOARDING_STATS_URL}/region-breakdown`, queryParams),
  getAdminStats: (queryParams) =>
    appendURL(`${ONBOARDING_STATS_URL}/admin`, queryParams),

  //Terminal Statistics endpoints
  getTerminalSummary: (queryParams) =>
    appendURL(`${BASE_API}/statistics/terminal/summary`, queryParams),
  getTerminalActivity: (queryParams) =>
    appendURL(`${BASE_API}/statistics/terminal/activity`, queryParams),
  getTransactionTypeStats: (queryParams) =>
    appendURL(`${BASE_API}/statistics/transaction/type`, queryParams),
  getRegionStats: (queryParams) =>
    appendURL(`${BASE_API}/statistics/transaction/region`, queryParams),
  getTransactionStatusStats: (queryParams) =>
    appendURL(`${BASE_API}/statistics/transaction/status`, queryParams),
  getTransactionStatsBreakdown: (queryParams) =>
    appendURL(`${BASE_API}/statistics/transaction/breakdown`, queryParams),

  //Transactions
  fetchTransactionTypes: () => BASE_API + "/transaction/type",
  getTransactionDetails: (queryParams) =>
    appendURL(`${BASE_API}/transaction`, queryParams),
  downloadTransactionDetails: (queryParams) =>
    appendURL(`${BASE_API}/transaction/export`, queryParams),

  //Custom Reports
  fetchTerminalActivity: (queryParams) =>
    FETCH_TERMINAL_REPORT + "/activity?" + queryParams,
  downloadTerminalActivity: (queryParams) =>
    FETCH_TERMINAL_REPORT + "/activity/export?" + queryParams,
  fetchTerminalPerformance: (queryParams) =>
    FETCH_TERMINAL_REPORT + "/performance?" + queryParams,
  downloadTerminalPerformance: (queryParams) =>
    appendURL(`${BASE_API}/report/terminal/performance/export`, queryParams),
  fetchAgentActivity: (queryParams) =>
    appendURL(`${BASE_API}/report/agent/activity`, queryParams),
  downloadAgentActivity: (queryParams) =>
    appendURL(`${BASE_API}/report/agent/activity/export`, queryParams),

  fetchAgentPerformance: (queryParams) =>
    appendURL(`${BASE_API}/report/agent/performance`, queryParams),
  downloadAgentPerformance: (queryParams) =>
    appendURL(`${BASE_API}/report/agent/performance/export`, queryParams),

  agentVerification: (queryParams) =>
    appendURL(`${BASE_API}/report/agent/verification`, queryParams),
  downloadAgentVerification: (queryParams) =>
    appendURL(`${BASE_API}/report/agent/verification/export`, queryParams),
};
